<template>
  <v-container fluid>
    <v-container fluid>
      <v-row class="d-flex" justify="space-between" align="center" align-content="center">
        <v-col cols="12" class="d-flex justify-end">
          <v-dialog v-model="configuration" :persistent="!validConfig" width="700px" max-width="100%" closable>
            <template #activator="{ attr, on }">
              <v-btn v-on="on" icon>
                <v-icon color="grey darken-1">mdi-cog</v-icon>
              </v-btn>
            </template>
            <v-card outlined elevation="0" width="700px" max-width="100%">
              <v-card-title class="headline d-flex justify-space-between">
                  <span>
                    {{ $t("menu.configuration") }}
                  </span>
                <v-icon :disabled="!validConfig" @click="configuration = !configuration">
                  mdi-close
                </v-icon>
              </v-card-title>
              <v-card-title>
              </v-card-title>
              <v-card-text>
                <v-form v-model="validConfig">
                  <v-row class="d-flex">
                    <v-col cols="6" class="d-flex justify-space-between align-start align-content-start">
                      <v-card outlined class="pa-4 d-flex flex-column mx-auto" style="width: 100%">
                        <v-switch inset class="mx-2 ma-0 pa-0" v-model="processSelected.isInternal" color="secondary" hide-details>
                          <template v-slot:label>
                            <label class="pt-1" ref="label">
                              {{$t('proccess.fields.internalStock')}}
                            </label>
                          </template>
                        </v-switch>
                      </v-card>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-space-between align-start align-content-start">
                      <v-card outlined class="pa-4 d-flex flex-column mx-auto" style="width: 100%">
                        <v-switch inset class="mx-2 ma-0 pa-0" v-model="processSelected.printLimit" color="secondary" hide-details>
                          <template v-slot:label>
                            <label class="pt-1" ref="label">
                              {{$t('reports.titles.printLimit')}}
                            </label>
                          </template>
                        </v-switch>
                      </v-card>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-space-between align-start align-content-start">
                      <v-card outlined class="pa-4 d-flex flex-column mx-auto" style="width: 100%">
                        <v-switch inset class="mx-2 ma-0 pa-0" v-model="processSelected.redirectQr" color="secondary" hide-details>
                          <template v-slot:label>
                            <label class="pt-1" ref="label">
                              {{$t('proccess.fields.redirectQr')}}
                            </label>
                          </template>
                        </v-switch>
                      </v-card>
                    </v-col>
                    <v-col cols="6" v-if="processSelected.processType && processSelected.processType.value !== 'AGRICULTURAL'">
                      <v-card outlined class="pa-4 d-flex flex-column mx-auto" style="width: 100%">
                        <v-switch inset class="mx-2 ma-0 pa-0" v-model="processSelected.automaticTraceability" color="secondary" hide-details>
                          <template v-slot:label>
                            <label class="pt-1" ref="label" style="width: 200px">
                              {{ $t('proccess.fields.automaticTraceability') }}
                            </label>
                          </template>
                        </v-switch>
                      </v-card>
                    </v-col>
                    <v-col cols="8"
                           v-if="processSelected.automaticTraceability"
                    >
                      <v-card outlined class="pa-4 d-flex flex-column mx-auto" style="width: 100%">
                        <v-autocomplete
                          :no-data-text="$t('general.fields.noDataAvailable')"
                          small
                          flat
                          outlined
                          dense
                          background-color="#EAEAEA80"
                          color="secondary"
                          clearable
                          item-color="secondary"
                          :items="reportTypes"
                          item-text="title"
                          item-value="value"
                          v-model="processSelected.reportType"
                          small-chips
                          :label="$t('documents.labels.selectExpired')"
                          :rules="required"
                        >
                          <template v-slot:selection="{ item }">
                            <v-chip small>
                              <span>{{ item.title }}</span>
                            </v-chip>
                          </template>
                        </v-autocomplete>
                      </v-card>
                    </v-col>
                    <v-col cols="12" class="my-0 py-0" v-if="processSelected.automaticTraceability && !processSelected.reportType">
                      <v-alert
                        dense
                        text
                        type="warning"
                        border="left"
                      >
                        <span v-html="$t('proccess.titles.reportSelectWarning')"></span>
                      </v-alert>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid class="my-0 py-0">
      <v-overlay :value="!ready" absolute color="white" :opacity="100">
        <v-progress-circular
          indeterminate
          size="64"
          color="secondary"
        />
      </v-overlay>
      <HeaderProcessComponent @update:validation-one="valid1 = $event" @update:process-type="setDefaultStructures()" :disable-s-d-t="disableSDT" :ready="ready" />
      <v-row>
        <v-col class="ma-0 pa-0 pr-1" cols="6">
          <DataTableStructureComponent @update:form-validation="validateStructureForm()" />
        </v-col>
        <v-col class="ma-0 pa-0 pl-1" cols="6">
          <DataTableGroupStructureComponent @update:form-validation="validateStructureForm()" />
        </v-col>
      </v-row>

    </v-container>
    <v-container fluid class="mb-5">
      <v-form class="d-flex justify-center align-center" ref="form1"
              v-model="valid2">
        <v-row>
          <v-col class="ma-0 pa-0 pr-1" cols="6">
            <p class="headline font-weight-regular" style="color: #232323">
              {{ $t('proccess.titles.details_process') }}
            </p>
            <v-card class="mt-3 pa-6"
                    outlined
                    v-if="!(structuresSelected.length > 0)"
            >
              <v-card-text class="text-lg-center">
                {{ $t('proccess.titles.nothingSelectedDetail') }}
              </v-card-text>
            </v-card>
            <draggable v-model="structuresSelected"
                       @start="dragStructure=true"
                       @end="dragStructure=false"
                       @change="onListChanged($event)"
            >
              <v-card v-for="(structure, index) in structuresSelected" outlined class="mt-3">
                <v-card-title class="justify-end pb-0">
                  <v-btn icon>
                    <v-icon>
                      mdi-drag
                    </v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <StructureComponent
                    :edited-index="editedIndex"
                    :key="structure.id"
                    :structure="structure"
                    :config="config"
                    :ref-key="structure.id"
                    @update:process-details="$set(proccessDetails, structure.id, $event)"
                    @update:selected-all="$set(structure, 'selectAll', $event)"
                  />
                </v-card-text>
              </v-card>
            </draggable>
          </v-col>
          <v-col class="ma-0 pa-0 pl-1" cols="6">
            <p class="headline font-weight-regular" style="color: #232323">
              {{ $t('proccess.titles.groupsDetails') }}
            </p>
            <v-card class="mt-3 pa-6"
                    outlined
                    v-if="!(groupStructuresSelected.length > 0)"
            >
              <v-card-text class="text-lg-center">
                {{ $t('proccess.titles.nothingSelectedGroups') }}
              </v-card-text>
            </v-card>
            <draggable v-model="groupStructuresSelected"
                       @start="dragGroup=true"
                       @end="dragGroup=false"
            >
              <v-card class="mt-3"
                      outlined
                      v-for="groupStructures in groupStructuresSelected"
                      v-bind:key="groupStructures.id">
                <v-card-title>
                  <span style="color: #37A98C">{{translate(groupStructures.languageKey, true) }}</span>
                  <v-spacer></v-spacer>
                  <v-icon small
                          @click="groupStructures.compress = !groupStructures.compress"
                          v-if="groupStructures.compress">
                    mdi-arrow-collapse-vertical
                  </v-icon>
                  <v-icon small
                          @click="groupStructures.compress = !groupStructures.compress"
                          v-if="!groupStructures.compress">
                    mdi-arrow-split-horizontal
                  </v-icon>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text v-if="groupStructures.compress">
                  <draggable
                    v-model="groupStructures.structure"
                    @start="drag=true"
                    @end="drag=false"
                    @change="onListChanged($event)"
                  >
                    <span v-for="(structureOfGroup, index) in groupStructures.structure">
                      <StructureComponent
                        :edited-index="editedIndex"
                        :key="structureOfGroup.id"
                        :structure="structureOfGroup"
                        :config="config"
                        :ref-key="`${structureOfGroup.id}-${groupStructures.id}`"
                        @update:process-details="$set(proccessGroupDetails, `${structureOfGroup.id}-${groupStructures.id}`, $event)"
                        @update:selected-all="$set(structureOfGroup, 'selectAll', $event)"
                      />
                    </span>
                  </draggable>
                </v-card-text>
              </v-card>
            </draggable>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
    <v-app-bar bottom elevation="0">
      <v-btn :disabled="loadSave" small tile outlined class="ml-4" color="gray" @click="cancel">
        {{$t('general.buttons.cancel')}}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn :loading="loadSave" small tile outlined class="mr-4" color="secondary"
             @click="save"
             :disabled="!validStructureForm"
      >
        {{$t('general.buttons.continue')}}
      </v-btn>
    </v-app-bar>
  </v-container>

</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import i18n from '@/plugins/i18n';
import _ from "lodash";
import CardList from '@/components/CardList';
import draggable from 'vuedraggable'
import LanguajeService from "@/services/LanguajeService";
import ReadMore from "@/components/ReadMoreComponent";
import Autocomplete from '@/components/Autocomplete';
import DataTableStructureComponent
  from "@/module/configuration/process/components/common/DataTableStructureComponent.vue";
import DataTableGroupStructureComponent
  from "@/module/configuration/process/components/common/DataTableGroupStructureComponent.vue";
import HeaderProcessComponent from "@/module/configuration/process/components/common/HeaderProcessComponent.vue";
import StructureComponent from "@/module/configuration/process/components/common/StructureComponent.vue";
import SingleStructureComponent from "@/module/prerecords/commons/SingleStructureComponent.vue";

const NOMENCLATURES = ['PRODUCT', 'EQUIPMENT', 'INPUT', 'SEASON', 'OPERATOR', 'MEASUREMENTUNIT', 'PRODUCTSIMPLE', 'EQUIPMENTSIMPLE', 'OPERATORSIMPLE', 'INPUTSIMPLE', 'SEASONSIMPLE', 'MEASUREMENTUNITSIMPLE'];
const OTHERS = ['TEXT', 'NUMBER', 'LOTE', 'LACRE', 'QR', 'TIME', 'DATA', 'DATATIME'];

export default {
  name: "TabMainProcess",
  components: {
    SingleStructureComponent,
    StructureComponent,
    HeaderProcessComponent,
    DataTableGroupStructureComponent,
    DataTableStructureComponent,
    ReadMore,
    CardList,
    draggable,
    Autocomplete
  },
  data() {
    return {
      editedIndex: -1,
      //drag
      drag: false,
      dragGroup: false,
      dragStructure: false,
      // STEPERS
      valid1: false,
      valid2: false,
      validConfig: true,
      loadSave: false,
      structures: [],
      proccessDetails: {},
      proccessGroupDetails: [],
      structuresOptional: ['LACRE', 'QR', 'TEXT', 'NUMBER', 'LOTE', 'TIME', 'DATA', 'DATATIME'],
      disableSDT: false,
      ready: true,
      configuration: false,
      reportTypes: [{
        title: i18n.t('reports.titles.traceability-report'),
        value: "TRACEABILITY"
      }, {
        title: i18n.t('reports.titles.recall-report'),
        value: "RECALL"
      }]
    }
  },
  async created() {
    this.config = JSON.parse(localStorage.getItem('config'))
    await this.initialize();
    this.order();
  },

  mounted() {
    this.$root.$on('clear:process-data', () => {
      this.cancel();
    });
  },
  computed: {
    ...mapGetters({
      processTypeEnum: 'proccess/processTypeEnum',
      details: 'details/details',
      groupDetailsByCompany: 'groupDetails/groupDetailsByCompany',
      groupDetailsDefaults: 'groupDetails/groupDetailsDefaults',
      detailsCode: 'details/detailsCode',
      required: 'general/requireRules',
      onlyPositiveNumberFormat: 'general/onlyPositiveNumberFormat',
      validUrlFormat: 'general/validUrlOrNull',
      languageStructure: 'general/languageStructure'
    }),
    storagesTypesByCompany() {
      return _.filter(this.$store.getters['storage_type/storagesTypesByCompany'], {isActive: true});
    },
    config: {
      get() {
        return this.$store.getters['general/config']
      },
      set(val) {
        this.$store.commit('general/SET_CONFIG', val)
      }
    },
    // Form condition title
    formTitle() {
      return (this.editedIndex === -1 ? i18n.t('general.titles.new') : i18n.t('general.titles.edit')) + ' ' + i18n.t('proccess.titles.new_process');
    },
    processSelected: {
      get() {
        return this.$store.getters['proccess/procces'];
      },
      set(val) {
        this.$store.commit('proccess/SET_PROCESS', val)
      }
    },
    groupStructuresSelected: {
      get() {
        return this.$store.getters['proccess/groupStructuresSelected'];
      },
      set(val) {
        this.$store.commit('proccess/SET_GROUP_SELECTED', val)
      }
    },
    structuresSelected: {
      get() {
        return this.$store.getters['proccess/structuresSelected'];
      },
      set(val) {
        this.$store.commit('proccess/SET_STRUCTURES_SELECTED', val)
      }
    },
    validStructureForm() {
      this.valid2 = true;
      _.forEach(this.structuresSelected, (structure) => {
        if (!this.structuresOptional.includes(structure.structure_type) && (!this.proccessDetails[structure.id] || this.proccessDetails[structure.id].length === 0)) {
          this.valid2 = false;
        }
      });
      _.forEach(this.groupStructuresSelected, (group) => {
        _.forEach(group.structure, (structure, key) => {
          if (!this.structuresOptional.includes(structure.structure_type) && (!this.proccessGroupDetails[structure.id + '-' + group.id] || this.proccessGroupDetails[structure.id + '-' + group.id].length === 0)) {
            this.valid2 = false;
          }
        });
      });
      return this.valid2 && this.valid1;
    },
  },
  methods: {
    ...mapActions({
      fetchListAuthorityProcess: 'authority/fetchListAuthorityProcess',
      fetchListProccess: 'proccess/fetchListProccess',
      fetchStorageTypesActiveByCompany: 'storage_type/fetchStorageTypesActiveByCompany',
      fetchListStructures: 'details/fetchListStructures',
      fetchListStructuresByCode: 'details/fetchListStructuresByCode',
      saveProccess: 'proccess/saveProccess',
      deleteProccess: 'proccess/deleteProccess',
      fetchAllGroupUnits: 'units/fetchAllGroupUnits',
    }),
    onListChanged(e, ref) {
      return;
    },
    validateStructureForm() {
      this.$refs.form1.validate()
    },
    addDisposition(groupStructures, structure) {
      _.forEach(groupStructures.structure, (structureGroup) => {
        if (structureGroup.id === structure.structure.id) {
          structureGroup['disposition'] = structure.structure.disposition;
          structureGroup['order'] = structure.structure.disposition;
          structureGroup['is_required'] = structure.structure.is_required;
          structureGroup['dataToSelect'] = structure.structure.dataToSelect;
          structureGroup['data_source'] = structure.structure.data_source;
          structureGroup['processStructureId'] = structure.recordStructureValue.processStructureId.id;
        }
      });
    },
    translate(key, uppercase) {
      return LanguajeService.getKey3(key)
    },
    async initialize() {
      const promises = [];
      this.profile = JSON.parse(localStorage.getItem('profile'));
      this.ready = false;
      promises.push(this.fetchStorageTypesActiveByCompany([this.$toast]));
      promises.push(this.fetchListStructures([this.profile, this.$toast]));
      promises.push(this.fetchListStructuresByCode([this.$toast]));
      promises.push(this.fetchAllGroupUnits(this.$toast));
      await Promise.all(promises).finally(() => {
        if (this.processSelected.id > 0) {
          localStorage.setItem('process:version', this.processSelected.processVersionId)
          localStorage.setItem('process:type', this.processSelected.processType)

          this.disableSDT = false;
          if (this.processSelected.sdt_to_show) {
            const sdt_to_show = this.storagesTypesByCompany.find(x => x.storage_device_type_id === this.processSelected.sdt_to_show.id);
            if (sdt_to_show) {
              this.$set(this.processSelected, 'sdt_to_show', sdt_to_show);
            } else {
              this.disableSDT = true;
            }
          }
          console.log(this.processSelected)
          this.processSelected.processType = this.processTypeEnum.find(x => x.value === this.processSelected.processType);

          this.editedIndex = this.processSelected.id;

          _.forEach(this.processSelected.processStructureOrganized.structures, (structure) => {
            const item = _.cloneDeep(_.find(this.details, (o) => {
              return o.id === structure.structure.id;
            }));
            if (item) {
              item.disposition = structure.structure.disposition;
              this.structuresSelected.push({
                ...structure.structure,
                ...item,
                processStructureId: structure.recordStructureValue.processStructureId.id
              })
            } else {
              const itemCode = _.find(this.detailsCode, (o) => {
                return o.id === structure.structure.id;
              });
              if (itemCode) {
                itemCode.disposition = structure.structure.disposition;
                this.structuresSelected.push({
                  ...structure.structure,
                  ...itemCode,
                  processStructureId: structure.recordStructureValue.processStructureId.id
                });
              }
            }
          });

          _.forEach(this.processSelected.processStructureOrganized.groups, (groupOrg) => {
            let group = _.find(this.groupDetailsByCompany, (o) => {
              return o.id === groupOrg.id;
            });
            if (group) {
              group['disposition'] = groupOrg.disposition;
              group['order'] = groupOrg.disposition;
              _.forEach(groupOrg.rows[0].values, (structure) => {
                this.addDisposition(group, structure);
              });

              this.groupStructuresSelected.push(group);
            } else {
              let group = _.find(this.groupDetailsDefaults, (o) => {
                return o.id === groupOrg.id;
              });
              group['disposition'] = groupOrg.disposition;
              group['order'] = groupOrg.disposition;
              _.forEach(groupOrg.rows[0].values, (structure) => {
                this.addDisposition(group, structure);
              });
              this.groupStructuresSelected.push(group);
            }
          });
        }
        this.ready = true;
      });
    },

    clearLocalStorage() {
      localStorage.removeItem('process:data');
      localStorage.removeItem('process:sdt')
      localStorage.removeItem('process:type')
      localStorage.removeItem('process:version')
    },

    cancel() {
      this.clearLocalStorage();
      this.$root.$emit('update:nomenclator-model', []);
      this.$root.$emit('clear:process-details', []);
      this.$set(this, 'structures', []);
      this.$set(this, 'proccessDetails', {});
      this.$set(this, 'proccessGroupDetails', []);
      this.$store.commit('proccess/SET_ORIGINAL_STATE_PROCESS');
      this.$store.commit('proccess/SET_GROUP_SELECTED', [])
      this.$store.commit('proccess/SET_STRUCTURES_SELECTED', [])
      this.$router.push('/nomenclators/proccess');
    },

    async save() {
      this.loadSave = true;
      let item = Object.assign({}, {...this.processSelected});
      item.company = {id: this.profile.company_id};

      const sdt_to_show = JSON.parse(localStorage.getItem('process:sdt'));
      if (sdt_to_show) {
        item.sdt_to_show = sdt_to_show;
      } else {
        item.sdt_to_show = this.disableSDT ? {id: item.sdt_to_show.id} : {id: item.sdt_to_show.storage_device_type_id};
      }

      localStorage.setItem('process:sdt', JSON.stringify(item.sdt_to_show));

      item.processType = item.processType.value ? item.processType.value : item.processType;
      // Translate
      item.language_key = LanguajeService.setKey3(item.proccess_name, item.language_key, !item.id ? this.languageStructure : null);

      let orderGroup = [];
      _.forEach(this.structuresSelected, (value, key) => {
        this.structureAddForSave(item, this.proccessDetails, value, key, false);
      });
      _.forEach(this.groupStructuresSelected, (value, key) => {
        value.disposition = key + 1;
        orderGroup.push({
          disposition: key + 1,
          groupStructure: value,
          group_structure_id: value.id,
          process_id: item.id
        });
        _.forEach(value.structure, (structure, key) => {
          this.structureAddForSave(item, this.proccessGroupDetails, structure, key, true, value.id);
        });
      });
      item.structures = this.structures;
      item.groupStructures = orderGroup;

      await this.saveProccess([item, this.editedIndex, this.$toast])

      await this.fetchListProccess([this.profile, this.$toast]).finally(() => {
        this.loadSave = false;
        if (this.editedIndex === -1) {
          this.editedIndex = this.processSelected.id;
          localStorage.setItem('process:version', this.processSelected.processVersionId)
        }
        localStorage.setItem('process:type', this.processSelected.processType)
        // this.$store.commit('proccess/SET_ORIGINAL_STATE_PROCESS');
        // this.$store.dispatch('authority/fetchListAuthorityProcess', [this.profile.id, this.$toast]);
        // this.$router.push({path: '/nomenclators/proccess'});
        this.structures = [];
        this.$emit('change:tab', 1);
      });
    },

    structureAddForSave(process, processDetails, value, key, isGroup, groupId) {
      let group = null;
      const keyIndex = groupId ? value.id + '-' + groupId : value.id;
      if (isGroup) {
        group = {id: groupId};
      }
      const lists = ['LIST', 'LISTSIMPLE'];
      if (lists.includes(value.structure_type)) {
        let dataSource = [];
        _.forEach(processDetails[keyIndex], (details, key) => {
          dataSource.push({
            id: null,
            name: LanguajeService.setKey3(details, null, this.languageStructure)
          });
        });
        this.structures.push({
          structure: {id: value.id},
          is_required: value.is_required ? 1 : 0,
          disposition: key + 1,
          structure_type: value.structure_type,
          data_source: dataSource,
          groupStructures: group
        })
      }
      if (NOMENCLATURES.includes(value.structure_type)) {
        let dataToSelect = [];
        _.forEach(processDetails[keyIndex], (details) => {
          dataToSelect.push(details.id);
        });
        this.structures.push({
          structure: {id: value.id},
          is_required: value.is_required ? 1 : 0,
          disposition: key + 1,
          structure_type: value.structure_type,
          dataToSelect: dataToSelect,
          groupStructures: group,
          selectAll: value.selectAll === 'undefined' ? false : value.selectAll
        })
      }
      if (OTHERS.includes(value.structure_type)) {
        this.structures.push({
          structure: {id: value.id},
          is_required: value.is_required ? 1 : 0,
          disposition: key + 1,
          structure_type: value.structure_type,
          groupStructures: group
        })
      }
    },

    setDefaultStructures() {
      const scope = this;
      let defaultsDetails = [];
      let defaultsGroupDetails = [];
      scope.structuresSelected = [];
      scope.groupStructuresSelected = [];
      if (scope.processSelected.processType) {
        if (scope.processSelected.processType.value === 'PROCESSING') {
          defaultsGroupDetails = _.filter(scope.groupDetailsDefaults, (o) => {
            return o.groupCode === 'GO' || o.groupCode === 'GI'
          });
        } else if (scope.processSelected.processType.value === 'AGRICULTURAL') {
          defaultsDetails = _.filter(scope.detailsCode, (o) => {
            return o.structureCode === 'S' || o.structureCode === 'P'
          });
        } else {
          const group = _.filter(scope.groupDetailsDefaults, (o) => {
            return o.groupCode === 'REEN'
          });
          // Solución Temporal ********
          let structures = [];
          structures.push(_.find(group[0].structure, {'structureCode': 'P'}));
          structures.push(_.find(group[0].structure, {'structureCode': 'C'}));
          structures.push(_.find(group[0].structure, {'structureCode': 'MU'}));
          structures.push(_.find(group[0].structure, {'structureCode': 'L'}));
          group[0].structure = structures;
          defaultsGroupDetails = group;
          // Solución Temporal ********
        }
      }

      _.forEach(defaultsDetails, (value) => {
        if (this.editedIndex !== -1)
          this.$root.$emit('initNomenclatorData', value)

        if (!_.find(scope.structuresSelected, {'id': value.id})) {
          scope.structuresSelected.push(value);
        }
      });
      _.forEach(defaultsGroupDetails, (value) => {
        if (this.editedIndex !== -1) {
          _.forEach(value.structure, (s) => {
            this.$root.$emit('initNomenclatorData', s)
          })
        }

        if (!_.find(scope.groupStructuresSelected, {'id': value.id})) {
          scope.groupStructuresSelected.push(value);
        }
      });

      // scope.order();
    },
    order() {
      this.structuresSelected = _.orderBy(this.structuresSelected, 'disposition');
      this.groupStructuresSelected = _.orderBy(_.map(this.groupStructuresSelected, (structureGroup) => {
        return {
          ...structureGroup,
          structure: _.orderBy(structureGroup.structure, 'disposition'),
          compress: true
        }
      }), 'disposition');
    }
  },

  destroyed() {
    this.clearLocalStorage()
    this.$set(this, 'proccessDetails', {})
    this.$set(this, 'proccessGroupDetails', [])
    this.$store.commit('proccess/SET_ORIGINAL_STATE_PROCESS');
    localStorage.removeItem('process:data')
  }
}
</script>

<style scoped>
</style>
